export default __webpack_public_path__ + "static/media/check.dd1dd42c.svg";